import { Logger, LoggerCategory } from "./Logger";

// Copyright (c) Docugami, Inc. All rights reserved.
var Enumerable = require('./linq');

export class BucketTimer {
    public static depthToCollect = 99;
    public static currentTime: number = 0;
    public static beginningTime: number = 0;
    public static currentBucket: string = "";
    public static buckets: any = {};

    static init() {
        BucketTimer.currentTime = (new Date()).getTime();
        BucketTimer.beginningTime = BucketTimer.currentTime;
        BucketTimer.currentBucket = '';
        for (let prop in BucketTimer.buckets) {
            if (typeof BucketTimer.buckets[prop] !== 'function' &&
                        prop !== 'currentTime' &&
                        prop !== 'currentBucket' &&
                        prop !== 'beginningTime') {
                delete BucketTimer.buckets[prop];
            }
        }
    }

    static bucket(depth: number, b: string) {
        var ct, diff, z;

        if (depth > BucketTimer.depthToCollect)
            return;

        ct = (new Date()).getTime();
        diff = ct - BucketTimer.currentTime;
        if (BucketTimer.currentBucket !== '') {
            if (BucketTimer.buckets[BucketTimer.currentBucket]) {
                BucketTimer.buckets[BucketTimer.currentBucket].time += diff;
                BucketTimer.buckets[BucketTimer.currentBucket].count += 1;
            }
            else {
                z = {
                    time: diff,
                    count: 1,
                };
                BucketTimer.buckets[BucketTimer.currentBucket] = z;
            }
        }
        BucketTimer.currentTime = ct;
        BucketTimer.currentBucket = b;
    }

    static lPad(str: string, padLength: number, padChar: string) {
        //Use: lPad(string, Number of Characters, Character to Pad)
        //Returns: string with the padChar appended to the left until the string
        // is padLength in length
        var p = Math.max((padLength + 1) - str.length, 0);
        return Array(p).join(padChar) + str;
    };

    static rPad(str: string, padLength: number, padChar: string) {
        //Use: openXml.util.rPad(string, Number of Characters, Character to Pad)
        //Returns: string with the padChar appended to the right until the string
        // is padLength in length
        var p = Math.max((padLength + 1) - str.length, 0);  //ignore jslint
        return str + Array(p).join(padChar);
    };

    public static dump() {
        var prop, s, a, a2, a3, a4, diffFromBeginning, i;

        diffFromBeginning = BucketTimer.currentTime - BucketTimer.beginningTime;
        BucketTimer.bucket(0, '');
        s = '';
        a = [];
        for (prop in BucketTimer.buckets) {
            if (typeof BucketTimer.buckets[prop] !== 'function' &&
                        prop !== 'currentTime' &&
                        prop !== 'currentBucket' &&
                        prop !== 'beginningTime') {
                let pct = (Math.floor(BucketTimer.buckets[prop].time / diffFromBeginning * 1000) / 10).toString() + "%"
                let str = BucketTimer.rPad(prop.toString(), 50, "-") + ': ' +
                    BucketTimer.lPad(BucketTimer.buckets[prop].time.toString(), 8, " ") + " " +
                    BucketTimer.lPad(pct, 8, " ") + " " +
                    BucketTimer.lPad(BucketTimer.buckets[prop].count.toString(), 8, " ");
                a.push(str);
            }
        }
        a2 = Enumerable.from(a);
        a3 = a2.orderBy("z=>z");
        a4 = a3.toArray();
        for (i = 0; i < a4.length; i += 1) {
            s += a4[i] + '\n';
        }

        s += "total time: " + diffFromBeginning + "\n";
        return s;
    };

    public static dumpToConsole() {
        var prop, a, a2, a3, a4, diffFromBeginning, i;

        diffFromBeginning = BucketTimer.currentTime - BucketTimer.beginningTime;
        BucketTimer.bucket(0, '');
        a = [];
        for (prop in BucketTimer.buckets) {
            if (typeof BucketTimer.buckets[prop] !== 'function' &&
                        prop !== 'currentTime' &&
                        prop !== 'currentBucket' &&
                        prop !== 'beginningTime') {
                let pct = (Math.floor(BucketTimer.buckets[prop].time / diffFromBeginning * 1000) / 10).toString() + "%"
                let str = BucketTimer.rPad(prop.toString(), 50, "-") + ': ' +
                    BucketTimer.lPad(BucketTimer.buckets[prop].time.toString(), 8, " ") + " " +
                    BucketTimer.lPad(pct, 8, " ") + " " +
                    BucketTimer.lPad(BucketTimer.buckets[prop].count.toString(), 8, " ");
                a.push(str);
            }
        }
        a2 = Enumerable.from(a);
        a3 = a2.orderBy("z=>z");
        a4 = a3.toArray();
        for (i = 0; i < a4.length; i += 1) {
            Logger.LogTrace(LoggerCategory.AssistedAuthoring, a4[i] + '\n');
        }

        Logger.LogTrace(LoggerCategory.AssistedAuthoring, "total time: " + diffFromBeginning + "\n");
    };
}
